export enum DraftType {
	Last,
	First,
	Both,
}
